import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: 'https://fb4f1c377d405f17d93ba70c1bfa08f3@o4508250606010368.ingest.us.sentry.io/4508296371109888',
  // Without this every build (stage included) reported as `production`
  environment: import.meta.env.VITE_APP_BUILD_NAME || import.meta.env.MODE,
  integrations: [Sentry.browserTracingIntegration()],

  tracesSampleRate: 0.3,
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/api\.ilmversity\.net\/api/,
    /^https:\/\/api-lgs\.ilmversity\.net\/api/,
    /^https:\/\/api-dev\.ilmversity\.net\/api/,
  ],
  enabled: import.meta.env.VITE_APP_SENTRY_ENABLED === 'true',
})
